import styled from 'styled-components';
import {
  COLOR_CV_5,
} from 'constants/colors';
import generatePicker from 'antd/lib/date-picker/generatePicker';
import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';

// export const StyledAntdDatePicker = styled(DatePicker)`
export const StyledAntdDatePicker = styled(generatePicker<Dayjs>(dayjsGenerateConfig))`
  color: pink;

  &.ant-picker-focused {
    border-color: ${COLOR_CV_5};
    box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
  }
  
  &:active, &:focus, &:hover {
    border-color: ${COLOR_CV_5};
    box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
  }
`;
